
import React from "react";
import ProductDevelopment from '../Components/Dashboard/Product-Portfolio/ProductDevelopment';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthProductDevelopment = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <ProductDevelopment /> : <SessionTimeoutRedirect />
}
export default AuthProductDevelopment;


